import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCallCosts } from "@/lib/api/voice";
import { CallCost } from "../type";

export const getCallCosts = createAsyncThunk<CallCost>(
  "callCosts/getCallCosts",
  async () => {
    const response = await fetchCallCosts();
    return response.data;
  }
);
